/**
 *
 */
import {
  get,
  getAuthToken,
  getHeaders,
  instance,
  post,
  removeAuthToken,
  setAuthToken,
  TResponse,
} from '@zhxk/web-components'
import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react'
import { getBaseOrigin } from 'utils/common'
import qs from 'qs'

export type TAuthContext = {
  token: string
  user: api.sso.User
  authorizing: boolean
  doLogin(): Promise<boolean>
  checkLogin(): Promise<boolean>
  logout(): void
}
export const authBaseUrl = getBaseOrigin('sso')

export const getSsoAuthUrl = async () => {
  const currentUrl = encodeURIComponent(window.location.href)
  const redirectUrl = encodeURIComponent(
    `${window.location.origin}/?back=${currentUrl}`
  )
  const { data } = await post<string>({
    url: `${authBaseUrl}/sso/getSsoLoginUrl?clientLoginUrl=${redirectUrl}`,
  })
  const ssoAuthUrl = data
  const qIndex = ssoAuthUrl.indexOf('?')
  const queryString = qIndex > -1 ? ssoAuthUrl.slice(qIndex + 1) : ''
  const searchQuery = queryString ? qs.parse(queryString) : {}
  return { url: ssoAuthUrl, searchQuery }
}
export const queryLogout = async () => {
  const data = await post<string>({
    url: `${authBaseUrl}/sso/signout`,
    method: 'post',
  })

  return data
}
export const AuthContext = createContext<TAuthContext>(null!)

export const USER_CACHE_KEY = 'user'

const defaultUser = () => ({
  userId: '',
  userCode: '',
  userName: '匿名用户',
  userPhone: '',
  identity: '',
  orgPathName: '',
})

type TAppProviderProps = {} & PropsWithChildren

export function AuthProvider(props: TAppProviderProps) {
  const [token, setToken] = useState(getAuthToken() || '')
  const [user, setUser] = useState<api.sso.User>(
    JSON.parse(localStorage[USER_CACHE_KEY] || 'null') || defaultUser()
  )
  const [authorizing, setAuthorizing] = useState(true)

  // const { get, post, env, instance } = useFetch()
  // const message = useMessage()

  const doLogin = async () => {
    const currentUrl = window.location.href
    const redirectUrl = `${window.location.origin}?back=${encodeURIComponent(currentUrl)}`

    const { code, data } = await post<string>({
      url: `/sso/getSsoLoginUrl`,
      query: {
        clientLoginUrl: redirectUrl,
      },
    })

    if (code === 0 || code === 200) {
      window.location.href = data
    }

    return false
  }

  const doLoginByTicket = async (ticket: string) => {
    const { code, data } = await post<string>({
      url: `/sso/doLoginByTicket`,
      query: { ticket },
    })
    if (code === 0 || code === 200) {
      return data
    } else {
      // TODO ticket 换 token 失败 则重新生成ticket
      // 严格模式可能出现重定向错误
      doLogin()
    }
    return ''
  }

  const isLogin = async () => {
    const { data } = await get<api.sso.isLogin>({
      url: '/sso/isLogin',
    })
    console.log('Auth: ', data)
    if (data.login) {
      localStorage.setItem(USER_CACHE_KEY, JSON.stringify(data.user))
      setUser(data.user!)
      setAuthorizing(false)
    }
    return data.login
  }

  const checkLogin = async () => {
    const search = new URLSearchParams(window.location.search.slice(1))
    const backTo = decodeURIComponent(search.get('back') || '')
    const ticket = search.get('ticket')
    if (ticket) {
      const nextToken = await doLoginByTicket(ticket)
      // console.log('next Token', token)
      if (nextToken) {
        setAuthToken(nextToken)
        setToken(nextToken)
        if (backTo) {
          window.location.href = backTo
        }
      }
    } else {
      setTimeout(async () => {
        const result = await isLogin()
        if (!result) {
          doLogin()
          return false
        }
      })
    }
    return true
  }

  const logout = async () => {
    removeAuthToken()
    localStorage.removeItem(USER_CACHE_KEY)

    await post({
      url: '/sso/signout',
    })

    setToken('')
    setUser(defaultUser())
    doLogin()
  }
  const handleLogout = async () => {
    try {
      await queryLogout()
      removeAuthToken()

      const { url } = await getSsoAuthUrl()
      window.location.href = url
    } catch (e: any) {
      console.error(e)
    }
  }

  useEffect(() => {
    // console.log('update auto instance fetch', instance)
    let requestId: number
    let responseId: number

    requestId = instance.interceptors.request.use((config) => {
      // console.log('auto request', config)
      Object.assign(config.headers, getHeaders())
      return config
    })

    responseId = instance.interceptors.response.use((response: any) => {
      // console.log('auth response', response)
      const { code } = response as TResponse
      if (code === 401) {
        return doLogin()
      }
      return response
    })

    return () => {
      instance.interceptors.request.eject(requestId)
      instance.interceptors.response.eject(responseId)
    }
  }, [token])

  const state = {
    token,
    user,
    authorizing,
    doLogin,
    checkLogin,
    logout: handleLogout,
  }

  return <AuthContext.Provider {...props} value={state} />
}

export function useAuth() {
  return useContext(AuthContext)
}

export function RequireAuth(props: { children?: React.ReactNode }) {
  const { children } = props
  // const auth = useAuth()
  useEffect(() => {
    // auth.checkLogin()
  }, [])

  // if (auth.authorizing) {
  //   return null
  // }
  return children
  // return children
}
